import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import LeadFormButton from '../../../components/LeadFormButton';

const ProcessCTA = () => {
  const benefits = [
    {
      icon: "Clock",
      title: "Processo Transparente",
      description: "Acompanhe cada etapa da criação do seu móvel através de fotos e vídeos exclusivos."
    },
    {
      icon: "Shield",
      title: "Garantia Vitalícia",
      description: "Confiança total na qualidade com garantia vitalícia na estrutura e 5 anos no acabamento."
    },
    {
      icon: "Users",
      title: "Artesãos Especializados",
      description: "Sua peça será criada por mestres artesãos com décadas de experiência."
    },
    {
      icon: "Leaf",
      title: "Sustentabilidade",
      description: "Madeiras certificadas e práticas sustentáveis em todo o processo produtivo."
    }
  ];

  const processGuides = [
    {
      title: "Guia Completo de Processos",
      description: "Manual detalhado com todas as etapas da criação artesanal",
      pages: "24 páginas",
      format: "PDF",
      icon: "FileText"
    },
    {
      title: "Catálogo de Madeiras",
      description: "Características técnicas e aplicações de cada tipo de madeira",
      pages: "16 páginas",
      format: "PDF",
      icon: "TreePine"
    },
    {
      title: "Técnicas de Acabamento",
      description: "Guia visual das diferentes opções de acabamento disponíveis",
      pages: "12 páginas",
      format: "PDF",
      icon: "Paintbrush"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary via-trust to-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-32 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-1/3 w-20 h-20 border border-white/20 rounded-full"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main CTA Section */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
              <Icon name="Sparkles" size={24} color="var(--color-accent-foreground)" strokeWidth={2.5} />
            </div>
            <span className="font-inter text-accent font-semibold text-lg">Comece Agora</span>
          </div>
          
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Pronto para Criar Seu
            <span className="block text-accent">Móvel dos Sonhos?</span>
          </h2>
          
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12">
            Nossa equipe de artesãos especializados está pronta para transformar sua visão em realidade. Cada peça é única, criada especialmente para você com o mais alto padrão de qualidade.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <LeadFormButton
              variant="default"
              size="xl"
              iconName="MessageCircle"
              iconPosition="left"
              className="bg-accent text-accent-foreground hover:bg-accent/90 shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Iniciar Projeto no WhatsApp
            </LeadFormButton>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-white/80">
            <div className="flex items-center space-x-2">
              <Icon name="Phone" size={20} />
              <span>(62) 99326-3202</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Mail" size={20} />
              <span>phmoveisconteporaneos@gmail.com</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={20} />
              <span>Seg-Sex: 8h às 18h</span>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {benefits?.map((benefit, index) => (
            <div key={index} className="text-center group">
              <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-accent group-hover:scale-110 transition-all duration-300">
                <Icon name={benefit?.icon} size={28} color="white" strokeWidth={2.5} />
              </div>
              <h3 className="font-semibold text-lg mb-3">{benefit?.title}</h3>
              <p className="text-white/80 leading-relaxed">{benefit?.description}</p>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div className="text-center mt-20">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-white/20">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="text-left">
                <h3 className="font-playfair text-2xl md:text-3xl font-bold mb-4">
                  Visite Nosso Ateliê
                </h3>
                <p className="text-white/90 leading-relaxed mb-6">
                  Conheça de perto nosso processo artesanal e converse diretamente com nossos mestres marceneiros. Agende uma visita e veja a magia acontecer.
                </p>
                <div className="space-y-3 text-white/80">
                  <div className="flex items-center space-x-3">
                    <Icon name="MapPin" size={16} />
                    <span>Rua dos Artesãos, 123 - Vila Madalena, São Paulo</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Clock" size={16} />
                    <span>Segunda a Sexta: 8h às 18h | Sábado: 9h às 14h</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Icon name="Car" size={16} />
                    <span>Estacionamento gratuito disponível</span>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="relative rounded-xl overflow-hidden">
                  <Image
                    src="https://images.unsplash.com/photo-1581539250439-c96689b516dd?w=500&h=300&fit=crop"
                    alt="Ateliê PH Móveis"
                    className="w-full h-64 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                </div>
                
                <div className="mt-6">
                  <Button
                    variant="default"
                    size="lg"
                    iconName="Navigation"
                    iconPosition="left"
                    className="bg-accent text-accent-foreground hover:bg-accent/90 w-full"
                  >
                    Agendar Visita ao Ateliê
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessCTA;